// 优先使用运行时配置（public/config.js），其次环境变量，最后回退到默认值
const RUNTIME_BASE_URL = typeof window !== 'undefined' ? window.__APP_CONFIG__?.BASE_URL : undefined;
const ENV_BASE_URL = process.env.REACT_APP_BASE_URL;
// export const BASE_URL = RUNTIME_BASE_URL || ENV_BASE_URL || 'https://airuat.lena.lenovo.com';
export const BASE_URL = RUNTIME_BASE_URL || ENV_BASE_URL || 'http://0.0.0.0:8000';
// 流式对话路径（可配置，如 /api/v1/stream/reception 或 /api/v1/stream/{xxx}）
const RUNTIME_STREAM_PATH = typeof window !== 'undefined' ? window.__APP_CONFIG__?.STREAM_PATH : undefined;
const ENV_STREAM_PATH = process.env.REACT_APP_STREAM_PATH;
export const STREAM_PATH = RUNTIME_STREAM_PATH || ENV_STREAM_PATH || '/api/v1/chat/stream';
export const STREAM_URL = `${BASE_URL}${STREAM_PATH}`;

// 埋点日志服务 URL
const RUNTIME_TRACKING_URL = typeof window !== 'undefined' ? window.__APP_CONFIG__?.TRACKING_URL : undefined;
const ENV_TRACKING_URL = process.env.REACT_APP_TRACKING_URL;
export const TRACKING_URL = RUNTIME_TRACKING_URL || ENV_TRACKING_URL || '';
